<template>

    <div class="layout__container">

        <div class="layout__padding-clear layout__width-80">

            <div class="layout__width-70 layout__padding-clear">
                <p class="text__align-center text__size-16 text__colour-grey">Photofixr™ offers expert photo
                    editing services, helping you to get the best
                    out of your property photography from just £2.95 per image.
                </p>
            </div>

            <div class="layout__padding-clear layout__width-100">
                <div class="layout__padding-20-0">
                <el-radio-group v-model="active" :max="1" class="layout__padding-clear layout__width-100">
                    <el-radio-button class="component__columns-6" label="brighten" :key="'brighten'">
                        <div class="layout__padding-20-0">
                            <div class="icon-brighten-circle text__colour-teal text__size-45"></div>
                            <div class="text__colour-teal layout__padding-15-0">Brighten Image</div>
                        </div>
                    </el-radio-button>
                    <el-radio-button class="component__columns-6" label="blue" :key="'blue'">
                        <div class="layout__padding-20-0">
                            <div class="icon-sky-circle text__colour-teal text__size-45"></div>
                            <div class="text__colour-teal layout__padding-15-0">Add Blue Sky</div>
                        </div>
                    </el-radio-button>
                    <el-radio-button class="component__columns-6" label="increase" :key="'increase'">
                        <div class="layout__padding-20-0">
                            <div class="icon-vibrance-circle text__colour-teal text__size-45"></div>
                            <div class="text__colour-teal layout__padding-15-0">Increase Vibrancy</div>
                        </div>
                    </el-radio-button>
                    <el-radio-button class="component__columns-6" label="correct" :key="'correct'">
                        <div class="layout__padding-20-0">
                            <div class="icon-distortion-circle text__colour-teal text__size-45"></div>
                            <div class="text__colour-teal layout__padding-15-0">Correct Distortion</div>
                        </div>
                    </el-radio-button>
                    <el-radio-button class="component__columns-6" label="grass" :key="'grass'">
                        <div class="layout__padding-20-0">
                            <div class="icon-add-grass-circle text__colour-red text__size-45"></div>
                            <div class="text__colour-red layout__padding-15-0">Fix Patchy Grass</div>
                        </div>
                    </el-radio-button>
                    <el-radio-button class="component__columns-6" label="remove" :key="'remove'">
                        <div class="layout__padding-20-0">
                            <div class="icon-remove-circle text__colour-red text__size-45"></div>
                            <div class="text__colour-red layout__padding-15-0">Remove an Object</div>
                        </div>
                    </el-radio-button>
                </el-radio-group>
                </div>
            </div>

        </div>

        <div class="layout__padding-clear layout__padding-60px-0 colour__background-light-grey layout__overflow-hidden">

            <div class="layout__padding-clear layout__width-100" id="brighten" v-if="active === 'brighten'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Increase-brightness-before-700x475.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Increase-brightness-after-700x475.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                        <h3 class="text__colour-teal layout__padding__top-50px">Brighten Image</h3>
                        <div class="text__colour-teal layout__padding__top-10px text__size-18 text__style-bold-900">Basic Photofix | £2.95 per image
                        </div>
                            <p class="text__colour-teal">(price inclusive of any basic photofix)</p>
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>If your property photos are looking a little dark or dull, bring them to life with a
                                basic brightness adjustment.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-100" id="blue" v-else-if="active === 'blue'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Add-Blue-Sky_Before_700x475@72dpi.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Add-Blue-Sky_After_700x475@72dpi.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                        <h3 class="text__colour-teal layout__padding__top-50px">Add Blue Sky</h3>
                        <div class="text__colour-teal layout__padding__top-10px text__size-18 text__style-bold-900">Basic Photofix | £2.95 per image
                        </div>
                            <p class="text__colour-teal">(price inclusive of any basic photofix)</p>
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>The weather isn’t always dependable. If you struggled to find a sunny day for
                                your property photos, the blue sky fix is what you need.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-100" v-else-if="active === 'increase'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Increase-Vibrance-Before_700x475.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Increase-Vibrance-After_700x475.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                        <h3 class="text__colour-teal layout__padding__top-50px">Increase Vibrancy</h3>
                        <div class="text__colour-teal layout__padding__top-10px text__size-18 text__style-bold-900">Basic Photofix | £2.95 per image</div>
                            <p class="text__colour-teal">(price inclusive of any basic photofix)</p>
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>Vibrancy brings colours to life, helping you show a property at its best. It often
                                works well with a brightness adjustment.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-100" v-else-if="active === 'correct'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/correct-distortion-before-700x475.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/correct-distortion-after-700x475.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                        <h3 class="text__colour-teal layout__padding__top-50px">Correct Distortion</h3>
                        <div class="text__colour-teal layout__padding__top-10px text__size-18 text__style-bold-900">Basic Photofix | £2.95 per image</div>
                            <p class="text__colour-teal">(price inclusive of any basic photofix)</p>
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>You may sometimes notice your photos have distorted out of shape, particularly at
                                the edges. This fix will restore the original proportions of the property.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-100" v-else-if="active === 'grass'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Add-grass-before.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/Add-Grass-After.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                        <h3 class="text__colour-red layout__padding__top-50px">Fix Patchy Grass</h3>
                        <div class="text__colour-red layout__padding__top-10px text__size-18 text__style-bold-900">Advanced Photofix | + £3.00 per image
                        </div>
                        <!--<p class="text__colour-teal">(price inclusive of any basic photofix)</p>-->
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>A patchy lawn can ruin a beautiful property photo. Fill in those gaps with luscious
                                green grass with this advanced photofix.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-100" v-else-if="active === 'remove'">
                <div class="component__columns-2">
                    <TwentyTwenty class="layout__width-60 layout__position-right"
                                  offset="0.5"
                                  before="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/remove-objects-before-700x475.jpg"
                                  beforeLabel="Before"
                                  after="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/remove-objects-after-700x475.jpg"
                                  afterLabel="After"/>
                </div>
                <div class="component__columns-2 layout__padding-20-0">
                    <div class="layout__width-50 layout__padding-0-40px">
                    <h3 class="text__colour-red layout__padding__top-50px">Remove an Object</h3>
                    <div class="text__colour-red layout__padding__top-10px text__size-18 text__style-bold-900">Advanced Photofix | + £3.00 per image
                    </div>
                        <div class="layout__padding-clear layout__padding__top-20px">
                            <p>Remove unwanted objects that have crept into your property photos. From bins to cars, this
                                photofix makes it look like they were never even there.</p>
                            <div class="text__size-12 layout__padding__top-10px">Reference photos need to be supplied for
                                large
                                object removals.
                            </div>
                        </div>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import TwentyTwenty from 'vue-twentytwenty'

    export default {
        name: "services",
        components: {
            TwentyTwenty,
            //Brighten
        },
        mounted() {
        },
        data() {
            return {
                // brightenBefore: '../../../images/photofixr/Increase-brightness-before-700x475.jpg'
                active: 'brighten'
            }
        }
    };
</script>